'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryNode = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _QueryNodeRegistry = require('./QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

var _nodeUuid = require('node-uuid');

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryNode = exports.QueryNode = function () {
    function QueryNode(params) {
        (0, _classCallCheck3.default)(this, QueryNode);

        for (var _len = arguments.length, children = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            children[_key - 1] = arguments[_key];
        }

        params = QueryNode.sanitizeParams.apply(QueryNode, [params].concat(children));
        this._nodeId = params.nodeId || _nodeUuid2.default.v4();
        var prototype = (0, _getPrototypeOf2.default)(this);
        var defaultData = prototype.constructor.defaultData || {};
        var accepts = prototype.constructor.accepts || params.accepts;
        this._type = prototype.constructor.name;
        this._accepts = accepts ? accepts.map(function (acceptable) {
            return typeof acceptable === 'string' ? acceptable : acceptable.name;
        }) : [];
        this._canHaveChildren = prototype.constructor.canHaveChildren || params.canHaveChildren;
        this._children = [];
        this._data = (0, _extends3.default)({}, defaultData, params.data);
        this._dataType = prototype.constructor.dataType;

        this.addChildren(params.children);
    }

    (0, _createClass3.default)(QueryNode, [{
        key: 'getRoot',
        value: function getRoot() {
            var currentNode = this;
            while (!currentNode.isRoot) {
                currentNode = currentNode.parentNode;
            }
            return currentNode;
        }
    }, {
        key: 'accepts',
        value: function accepts(child) {
            return _lodash2.default.some(this._accepts, function (acceptable) {
                return _QueryNodeRegistry2.default.hasAncestorWithName(child.type, acceptable);
            });
        }
    }, {
        key: 'hasDescendant',
        value: function hasDescendant(child) {
            var currentNode = child;
            while (!currentNode.isRoot) {
                if (currentNode.parentNode === this) {
                    return true;
                }
                currentNode = currentNode.parentNode;
            }
            return false;
        }
    }, {
        key: 'hasChild',
        value: function hasChild(child) {
            return _lodash2.default.indexOf(this._children, child) >= 0;
        }
    }, {
        key: '_canAddChild',
        value: function _canAddChild(child) {
            if (!this.canHaveChildren) {
                throw new Error('This object cannot have children');
            }
            if (this === child) {
                throw new Error('Cannot add an object as a child of itself.');
            }
            if (!this.accepts(child)) {
                throw new Error('This object does not accept the child\'s type ' + (child && child.type));
            }
            var isAlreadyChild = this.hasChild(child);
            if (!isAlreadyChild && !child.isRoot) {
                throw new Error('Cannot add a child element that isn\'t a root node.');
            }
            return !isAlreadyChild;
        }
    }, {
        key: 'addChild',
        value: function addChild(child) {
            if (this._canAddChild(child)) {
                this._children.push(child);
                child._parentNode = this;
            }
        }
    }, {
        key: 'addChildren',
        value: function addChildren(children) {
            var _this = this;

            if (!this.canHaveChildren) {
                return;
            }

            for (var _len2 = arguments.length, otherChildren = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                otherChildren[_key2 - 1] = arguments[_key2];
            }

            if (children instanceof QueryNode) {
                this.addChild(children);
                [].concat(otherChildren).forEach(function (child) {
                    return _this.addChild(child);
                });
                return;
            }
            [].concat((0, _toConsumableArray3.default)(children), otherChildren).forEach(function (child) {
                return _this.addChild(child);
            });
        }
    }, {
        key: 'removeChild',
        value: function removeChild(child) {
            _lodash2.default.pull(this._children, child);
            child._parentNode = null;
        }
    }, {
        key: 'replaceChildAt',
        value: function replaceChildAt(index, newChild) {
            if (!this.children[index]) {
                return;
            }
            if (this._canAddChild(newChild)) {
                this.children[index]._parentNode = null;
                this.children[index] = newChild;
                newChild._parentNode = this;
            }
        }
    }, {
        key: 'removeChildren',
        value: function removeChildren(children) {
            var _this2 = this;

            for (var _len3 = arguments.length, otherChildren = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                otherChildren[_key3 - 1] = arguments[_key3];
            }

            if (children instanceof QueryNode) {
                this.removeChild(children);
                [].concat(otherChildren).forEach(function (child) {
                    return _this2.removeChild(child);
                });
                return;
            }
            [].concat((0, _toConsumableArray3.default)(children), otherChildren).forEach(function (child) {
                return _this2.removeChild(child);
            });
        }
    }, {
        key: 'detach',
        value: function detach() {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        }
    }, {
        key: 'getDataType',
        value: function getDataType() {
            return this._dataType;
        }
    }, {
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            throw new Error('Not Implemented for QueryNode.');
        }
    }, {
        key: 'nodeId',
        get: function get() {
            return this._nodeId;
        }
    }, {
        key: 'type',
        get: function get() {
            return this._type;
        }
    }, {
        key: 'data',
        get: function get() {
            return this._data;
        }
    }, {
        key: 'children',
        get: function get() {
            return this._children;
        }
    }, {
        key: 'canHaveChildren',
        get: function get() {
            return this._canHaveChildren;
        }
    }, {
        key: 'parentNode',
        get: function get() {
            return this._parentNode;
        },
        set: function set(value) {
            if (!(value instanceof QueryNode)) {
                throw new Error('Cannot set parent to a non-Query Node.');
            }
            if (this.hasDescendant(value)) {
                throw new Error('Parent node loop occurred!', 'value: ' + value);
            }
            this.detach();
            value.addChild(this);
        }
    }, {
        key: 'isRoot',
        get: function get() {
            return this._parentNode == null;
        }
    }], [{
        key: 'sanitizeParams',
        value: function sanitizeParams(params) {
            for (var _len4 = arguments.length, children = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                children[_key4 - 1] = arguments[_key4];
            }

            if (typeof params === 'function') {
                params = params();
            }

            if (params instanceof Array) {
                params = { children: params };
            } else if (params instanceof QueryNode) {
                children = [params].concat(children || []);
            }

            params = (0, _extends3.default)({}, defaultParams, params);

            if (children instanceof Array && children.length >= 1) {
                params.children = children;
            }
            return params;
        }
    }]);
    return QueryNode;
}();

var defaultParams = {
    type: 'QueryNode',
    accepts: [QueryNode],
    canHaveChildren: false,
    children: [],
    terminalNode: true
};

exports.default = QueryNode;